import {get, map, filter} from 'lodash';
import {columnsFn, readFn} from './utils';
import * as SystemConfig from './systemconfig';
import i18n from 'src/i18n';

export const columns = columnsFn({
  area: {
    type: 'select', readonly: true,
    items: map(Object.keys(i18n.s('fields.service_areas')), x => 'fields.service_areas.' + x),
  },
  district: {
    type: 'select',
    label: 'fields.district',
    list: false,
    valueKey: 'id',
    items(value, model, spec, search) {
      return readFn('getCurrentSystemconfig', '').call(this, null/*'790874a0-4388-11e7-8c53-010f4582d9f8'*/, SystemConfig, [])
        .then(response => {
          let data = get(response, 'selection.district_area_fee');
          if (search) {
            let re = JSON.stringify(search).replace(/^"|"$/g, '').toLowerCase();
            data = filter(data, x => {
              return JSON.stringify(x).toLowerCase().indexOf(re) >= 0;
            });
          }
          return map(data, x => ({value: x, label: i18n.S(x.location)}));
        });
    },
    set(model, spec, v) {
      this.$set(model, 'area', v.area);
      this.$set(model, 'district', v.id);
    },
    get(model) {
      return model.district ? {id: model.district} : null;
    },
  },
  address: {type: 'string'},
});

export function title(model) {
  return get(model, 'address');
}



// WEBPACK FOOTER //
// ./src/schemas/service_location.js